import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanDeactivate, Router, RouterStateSnapshot,
} from "@angular/router";
import { UserProfileComponent } from "src/app/features/settings/user-profile/user-profile.component";
import { PatientRole } from "src/app/models/patient-role.model";
import { LoginIntentService } from "src/app/services/login-intent.service";
import { UserInfoService } from "src/app/services/user-info.service";
import { getPathWithoutQueryAndHash } from "src/app/shared/utils/url.utils";
import { TranslateService } from "@ngx-translate/core";
import { ModalService } from "src/app/services/modal.service";
import { take } from "rxjs/operators";

@Injectable({
  providedIn: 'root',
})
export class ContactInfoDeepLinkGuard implements CanDeactivate<UserProfileComponent> {

  constructor(
    private loginIntent: LoginIntentService,
    private userInfoService: UserInfoService,
    private translate: TranslateService,
    private modalService: ModalService,
    private router: Router,
  ) {
  }

  canDeactivate(
    _component: UserProfileComponent,
    _currentRoute: ActivatedRouteSnapshot,
    _currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): boolean | Promise<boolean> {

    if (!nextState) return false;

    const pending = this.loginIntent.peekRouteIntent();
    const role = this.userInfoService.getSessionContext()?.patientRole;
    const nextPath = getPathWithoutQueryAndHash(nextState.url);

    if (!pending) return true;
    if (role === PatientRole.EXTERNAL || role === PatientRole.PAID_CUSTOMER) {
      this.loginIntent.clear();
      return true;
    }
    if (role !== PatientRole.ACTIVE) return true;
    if (nextPath === pending.path) return true; // else modal loop

    const content = this.translate.instant(`deepLink.redirectInfo.${pending.source}`);
    this.modalService.showImportantInfoShortModal(content)
      .afterClosed()
      .pipe(take(1))
      .subscribe(() => this.router.navigate([pending.path]));
    return false;
  }

}
